<template>
  <header id="app-gym-header" class="header-container" style="background: #fff">
    <div class="header">
      <div class="logo-container" @click="$router.push('/')">
        <a href="#">
          <img src="../assets/logo.png" alt="logo" />
        </a>
      </div>
      <div class="navbar">
        <ul class=" ">
          <li class="navbar-item" v-for="(item, index) in tabList" :key="index">
            <router-link
              :to="item.url"
              :class="nowPath == item.url && 'router-link-active'"
            >
              {{ item.name }}
            </router-link>
          </li>
        </ul>
      </div>
      <div class="team-btn">
        <a class="btn" href="https://saas.tuielf.com/supplier" target="_blank">
          管理中心
        </a>

        <div class="more" @click="showMenu">
          <img src="../assets/more.png" alt="" />
        </div>
      </div>

      <div
        class="navbar-collapse"
        :style="showMenuWrap ? 'display: block;' : 'display: none;'"
      >
        <div class="close">
          <img src="../assets/close.png" alt="" @click="closeMenu" />
        </div>
        <div class="mobile_menu_wrap">
          <!-- <div class="m-brand-logo text-center">
              <a href="!#"><img src="../assets/logo.png" alt="" /></a>
            </div> -->
          <nav class="mobile-main-navigation">
            <ul id="m-main-nav" class="navbar-nav">
              <li
                class="menu-item"
                :style="nowPath == item.url ? 'background-color: #3D8CFF;' : ''"
                v-for="(item, index) in tabList"
                :key="index"
                @click="closeMenu"
              >
                <router-link :to="item.url">{{ item.name }}</router-link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import $ from "jquery";
// import checkHost from "../../public/host";
export default {
  name: "Header",
  data() {
    // 参数
    return {
      nowPath: "/",
      tabList: [
        { name: "首页", url: "/" },
        // { name: "官网公告", url: "/notice" },
        { name: "帮助中心", url: "/help" },
        // { name: "联系我们", url: "/contact" },
        { name: "关于我们", url: "/about" },
      ],
      logoPic: "http://tuielf.cn/22.png",
      beian: {},
      showMenuWrap: false,
    };
  },
  watch: {
    $route: {
      handler: function (val) {
        var that = this;
        that.nowPath = val.fullPath;
        window.scrollTo(0, 0);
      },
      // 深度观察监听
      deep: true,
    },
  },
  created() {
    // const beian = checkHost(window.location.host);
    const beian = localStorage.getItem("beian");
    this.beian = JSON.parse(beian);
  },
  mounted() {},
  methods: {
    showMenu() {
      document.body.classList.add("navbar-on");
      this.$mask.show();
      this.showMenuWrap = true;
    },
    closeMenu() {
      document.body.classList.remove("navbar-on");
      this.$mask.hide();
      setTimeout(() => {
        this.showMenuWrap = false;
      }, 300);
    },
  },
};
</script>

<style lang="less" scoped>
.header-container {
  position: sticky;
  top: 0;
  height: 60px;
  box-shadow: 0 2px 10px 0 rgba(51, 51, 51, 0.1);
  z-index: 99;

  .header {
    margin: 0 auto;
    padding: 0 20px;
    max-width: 1200px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo-container {
      margin-right: 80px;
      width: 82px;
      // height: 23px;

      a {
        display: flex;
        align-items: center;
        height: 100%;
      }
      img {
        height: 100%;
      }

      .logo-tit {
        font-weight: 500;
        font-size: 16px;
        color: #1d2129;
      }
    }

    .navbar {
      flex: 1;
      height: 100%;

      ul {
        display: flex;
        align-items: center;
        height: 100%;

        .navbar-item {
          margin-right: 50px;
          height: 100%;

          a {
            position: relative;
            display: flex;
            align-items: center;
            height: 100%;
          }

          .router-link-active {
            color: #4080ff;

            &::after {
              position: absolute;
              left: 0;
              bottom: 0;
              content: "";
              width: 100%;
              height: 2px;
              background-color: #4080ff;
            }
          }

          &:hover {
            a {
              color: #4080ff;
            }
          }
        }
      }
    }

    .team-btn {
      display: flex;
      align-items: center;

      .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 96px;
        height: 34px;
        font-size: 16px;
        color: #ffffff;
        background: linear-gradient(313deg, #4080ff 0%, #4aa2ff 100%);
        border-radius: 6px;
        cursor: pointer;
      }

      .more {
        margin-left: 20px;
        width: 28px;
        height: 28px;
        display: none;
      }
    }
  }
}

.navbar-collapse {
  position: fixed;
  bottom: 0;
  top: 0;
  right: 100%;
  z-index: 998;
  height: 100% !important;
  width: 80% !important;
  background-color: #4080ff;

  .close {
    display: flex;
    justify-content: flex-end;
    padding: 12px 16px;
    border-bottom: 1px solid #fff;
    img {
      width: 28px;
      height: 28px;
    }
  }

  .mobile_menu_wrap {
    .mobile-main-navigation {
      .navbar-nav {
        .menu-item {
          padding: 0 20px;
          height: 49px;

          a {
            display: flex;
            align-items: center;
            width: 100%;
            height: 100%;
            color: #fff;
            font-size: 16px;
          }
        }
      }
    }
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
}

@media (min-width: 768px) and (max-width: 991px) {
}

@media (max-width: 767px) {
  .header-container {
    .header {
      .navbar {
        display: none;
      }

      .team-btn {
        .more {
          display: block;
        }
      }
    }
  }
}
</style>
